import type { IFilePayload, IFilesPayload } from 'src/types';

export function getFilesDiff(newFiles: IFilePayload[], oldFiles: { id: string }[]): IFilesPayload {
  const removedFiles = oldFiles.reduce((acc, curr) => {
    if (!newFiles.some((newFile) => newFile.uid === curr.id)) {
      acc.push(curr.id);
    }

    return acc;
  }, [] as string[]);

  const addedFiles = newFiles.filter((newFile) => !newFile.uid && !!newFile.content);

  return {
    addedFiles,
    removedFiles,
  };
}
